(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["location-consent-popup"]) return;
  try {
    
  (() => {
    const consentKey = 'nutu-location-consent-v1';

    document.querySelectorAll('.js-location-consent').forEach((component) => {
      const overlay = component.querySelector('[data-location-overlay]');
      const dialog = component.querySelector('.location-consent__dialog');
      const title = component.querySelector('[data-location-title]');
      const body = component.querySelector('[data-location-body]');
      const cta = component.querySelector('[data-location-cta]');
      const countryInput = component.querySelector('#LocationConsentEnglishForm-' + component.id.replace('LocationConsentPopup-', '') + ' [name="country_code"]');
      const stayForm = component.querySelector('#LocationConsentStayForm-' + component.id.replace('LocationConsentPopup-', ''));
      const manualCountry = component.querySelector('[data-location-country]');
      const manualLanguage = component.querySelector('[data-location-language]');
      const isForcedPreview = new URLSearchParams(window.location.search).get('location-popup-preview') === '1';
      const isDesignMode = component.dataset.designMode === 'true';
      let countries = {};

      try {
        countries = JSON.parse(component.querySelector('[data-location-countries]').textContent);
      } catch (error) {
        return;
      }

      const rememberChoice = () => window.localStorage.setItem(consentKey, '1');
      const configure = (countryCode) => {
        const country = countries[countryCode];

        if (!country) return false;

        const countryName = new Intl.DisplayNames(['en'], { type: 'region' }).of(countryCode) || country.name;
        title.textContent = `Shopping from ${countryName}?`;
        body.textContent = `Switch to our English store and shop in ${country.currency}. You can change your country or language at any time.`;
        cta.textContent = `SHOP IN ENGLISH · ${country.currency}`;
        countryInput.value = countryCode;
        manualCountry.value = countryCode;
        if (manualLanguage.querySelector('option[value="en"]')) manualLanguage.value = 'en';
        return true;
      };

      const displayNames = new Intl.DisplayNames(['en'], { type: 'region' });
      manualCountry.querySelectorAll('option').forEach((option) => {
        const country = countries[option.value];
        if (!country) return;
        option.textContent = `${displayNames.of(option.value) || country.name} (${country.currency})`;
      });

      const open = () => {
        overlay.hidden = false;
        document.documentElement.classList.add('location-consent-open');
        dialog.focus();
      };

      component.querySelectorAll('[data-location-choice]').forEach((button) => {
        button.addEventListener('click', rememberChoice);
      });

      component.querySelector('[data-location-close]').addEventListener('click', () => {
        rememberChoice();
        stayForm.requestSubmit();
      });

      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && !overlay.hidden) {
          rememberChoice();
          stayForm.requestSubmit();
        }
      });

      if (isForcedPreview || isDesignMode) {
        if (configure(countries.DE ? 'DE' : Object.keys(countries).find((code) => code !== 'PL'))) open();
        return;
      }

      if (window.localStorage.getItem(consentKey)) return;

      const currentCountry = window.Shopify && window.Shopify.country ? window.Shopify.country : 'PL';
      const root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
      const endpoint = `${root}browsing_context_suggestions.json?country[enabled]=true&country[exclude]=${encodeURIComponent(currentCountry)}&language[enabled]=true`;

      fetch(endpoint, { credentials: 'same-origin' })
        .then((response) => response.ok ? response.json() : null)
        .then((data) => {
          const suggestion = data && data.suggestions && data.suggestions[0] && data.suggestions[0].parts && data.suggestions[0].parts.country;
          const detected = data && data.detected_values && data.detected_values.country;
          const countryCode = (suggestion && suggestion.handle) || (detected && detected.handle);

          if (countryCode && countryCode !== 'PL' && configure(countryCode)) open();
        })
        .catch(() => {});
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
